export enum QuestionStatus {
  Published = "Published",
  Unpublished = "Unpublished",
}
